import script from "./EntryLink2.vue?vue&type=script&setup=true&lang=js"
export * from "./EntryLink2.vue?vue&type=script&setup=true&lang=js"

import "./EntryLink2.vue?vue&type=style&index=0&id=35d8debb&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/user/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.12_vue@3.5.12_typescript@5.6.3__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d8debb"]])

export default __exports__